import axios from "axios"

export enum Trade {
    VIDEO = "video",
    INSTA_COMMUNICATION = "insta_communication",
    HEADSET = "headset",
    EMA = "ema"
}

export interface IProductKategorie {
    id: number,
    name: string
}

export interface IGewerke {
    id: number,
    name: string
}

export interface IHersteller {
    id: number,
    name: string
}

export interface AppData {
    produktKategorie: IProductKategorie[],
    gewerke: IGewerke[],
    hersteller: IHersteller[],
    failedToLoad: boolean
}

export default async function() : Promise<AppData> {

    const urlGewerke = 'https://vi2vi.ninoxdb.de/share/3lgckbtsq4p949hq42lyobb19rcbxy2ck68k';
    const urlHersteller = 'https://vi2vi.ninoxdb.de/share/uhe6mftbvwbhllnczoiankm324bpculepqv1';
    const urlKategorien = 'https://vi2vi.ninoxdb.de/share/e8uy5a0s7pyht2v2i3bbgp7pksdbr2aiobw9';

    try {
        const [
            gewerke,
            hersteller,
            kategorien
        ] = await Promise.all([
            axios.get(urlGewerke),
            axios.get(urlHersteller),
            axios.get(urlKategorien),
        ]);

        console.log('---------------------------------------');
        console.log('API Gewerke: ', gewerke.data);
        console.log('API Hersteller: ', hersteller.data);
        console.log('API Kategorien: ', kategorien.data);
        console.log('---------------------------------------');

        return {
            hersteller: hersteller
                .data
                .filter((hersteller: any) => typeof hersteller.id === "number" && typeof hersteller.name === "string")
                .map(({id, name}: {id: number, name: string}) : IHersteller => {
                    return {
                        id: id as number,
                        name: name as string
                    }
                }),
            gewerke: gewerke
                .data
                .filter((gewerk: any) => {
                    return typeof gewerk.nr === "number" && typeof gewerk.gewerk === "string"
                })
                .map(({id, gewerk}: {id: number, gewerk: string}) : IGewerke => {
                    return {
                        id: id,
                        name: gewerk
                    }
                }),
            produktKategorie: kategorien
                .data
                .filter((kategorie: any) => {
                    return typeof kategorie.nr === "number" && typeof kategorie.kategorie === "string"
                })
                .map(({nr, kategorie}: {nr: number, kategorie: string}) : IProductKategorie => {
                    return {
                        id: nr,
                        name: kategorie
                    }
                }),
            failedToLoad: false
        }

    } catch (e) {
        return {
            hersteller: [],
            gewerke: [],
            produktKategorie: [],
            failedToLoad: true
        }
    }

}